module.exports = __webpack_public_path__ + "img/2-G_o0P0-zlS4gxoGSgx4D.271142b6.svg";